import { defineStore } from 'pinia';

export interface State {
  unreadCount: number;
}

export const useNotificationsStore = defineStore('notifications', {
  state: (): State => ({
    unreadCount: 0,
  }),
  actions: {
    decrementUnreadCount(amount: number = 1) {
      this.unreadCount -= amount;
    },

    incrementUnreadCount(amount: number = 1) {
      this.unreadCount += amount;
    },
  },
});
